import { useState, useCallback, useEffect } from 'react';
import { GetPallets } from '../../libs/GraphQL';
import { deduplicatePallets, sortPalletsForDisplay } from './palletUtils';

export default function useFetchPallets(selectedDate) {
  const [pallets, setPallets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPallets = useCallback(async () => {
    if (!selectedDate) return;
    setIsLoading(true);
    setError(null);
    try {
      const formattedDate = selectedDate.format('YYYY-MM-DD');
      const response = await GetPallets({ productionDate: formattedDate });
      const palletData = response?.data?.getPallets || [];
      setPallets(sortPalletsForDisplay(deduplicatePallets(palletData)));
    } catch (err) {
      console.error('Error fetching pallets:', err);
      setError('Failed to load pallet data. Please try again.');
      setPallets([]);
    } finally {
      setIsLoading(false);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchPallets();
  }, [fetchPallets]);

  return { pallets, isLoading, error, fetchPallets };
}
